import { put, all, takeLatest } from "redux-saga/effects"
import { INSERT_RELATIVES_REQUEST, INSERT_RELATIVE_REQUEST } from "./constants"

import {
  ResponseInsertRelative,
  InsertRelativeRequest,
  RelativeApi,
} from "types/payload"
import {
  insertRelativeSuccess,
  insertRelativeError,
} from "./actions"
import config from "react-global-configuration"
import { request } from "lib/request"
import { Action, GWatcher } from "types/redux"
import { RELATIVES_REQUEST } from "client/services/constants"
import Compliance, { formatCustomerINSPayload } from "lib/api-compliance"

async function insertRelativeApi(
  payload?: InsertRelativeRequest
): Promise<ResponseInsertRelative> {
  const formattedPayload = formatCustomerINSPayload(payload);
  return await request(config.get("patient.post.relative"), {
    method: "POST",
    payload: formattedPayload,
  })
}

function* insertRelativeFlow({ payload }: Action<InsertRelativeRequest>) {
  try {
    const response: ResponseInsertRelative = yield insertRelativeApi(payload)
    yield put(insertRelativeSuccess(response.relative))
  } catch (error) {
    yield all([put(insertRelativeError(error as string))])
  }
}

function* insertRelativesFlow({ payload }: Action<RelativeApi[]>) {
  try {
    payload.forEach(async (relative: RelativeApi) => {
      return await insertRelativeApi(relative)
    })
    yield put({ type: RELATIVES_REQUEST })
  } catch (error) {
    console.error("Error during auto insert relatives")
  }
}
function* relativeWatcher(): GWatcher {
  yield takeLatest(INSERT_RELATIVE_REQUEST, insertRelativeFlow)
  yield takeLatest(INSERT_RELATIVES_REQUEST, insertRelativesFlow)
}

export default relativeWatcher
